import dayjs from '@/libs/util.date.js'
import { add, subtract, multiply, divide, round } from '@/libs/util.number.js'
export default {
  data() {
    return {
      formData: {
        estmatDaysOfSupply: 0,
        estmatSoldoutDate: '',
        suggestedSubmitQty: 0,
        suggestedReplenishmentDate: '',
        etaInvDays: 0,
      },
    }
  },
  computed: {
    /**
     * 预计可售天数
     * FBA库存/实际日销量
     */
    calc_estmatDaysOfSupply() {
      const { fbaQty, advQtyBeforeRepPerDay, soldQtyLast3Day } = this.formData
      return round(divide(fbaQty, advQtyBeforeRepPerDay || soldQtyLast3Day), 2)
    },
    /**
     * 预计断货日期
     * 当天日期+可售天数+中途断货日期
     */
    calc_estmatSoldoutDate() {
      // 预计可售天数
      const estmatDaysOfSupply = this.calc_estmatDaysOfSupply
      // 中途断货天数
      const { halfwayOutageDays } = this.formData
      // 当天日期
      const today = dayjs()
      return today
        .add(estmatDaysOfSupply || 0, 'day')
        .add(halfwayOutageDays || 0, 'day')
        .format('YYYY-MM-DD')
    },
    /**
     * 建议补货数量
     * (实际日销量+到货日预估日销)/2x30+到货日活动销量
     */
    calc_suggestedSubmitQty() {
      const {
        advQtyBeforeRepPerDay,
        soldQtyAfterRepPerDay,
        advQtyAfterRepPerDay,
      } = this.formData

      return round(
        add(
          multiply(
            divide(add(advQtyBeforeRepPerDay, soldQtyAfterRepPerDay), 2),
            30
          ),
          advQtyAfterRepPerDay
        ),
        0
      )
    },
    /**
     * 建议补货时间
     * 预计断货日期-90天
     */
    calc_suggestedReplenishmentDate() {
      const estmatSoldoutDate = this.calc_estmatSoldoutDate
      if (!estmatSoldoutDate) return ''

      return dayjs(estmatSoldoutDate)
        .subtract(90, 'day')
        .format('YYYY-MM-DD')
    },
    /**
     * 补货后库存天数
     * (实际补货数量-到货日活动销量)/((实际日销量+到货日预估日销)/2)+(90-(预计断货日期-当天日期))
     */
    calc_etaInvDays() {
      const {
        submitQty,
        advQtyAfterRepPerDay,
        advQtyBeforeRepPerDay,
        soldQtyAfterRepPerDay,
      } = this.formData

      const today = dayjs(dayjs().format('YYYY-MM-DD'))
      const estmatSoldoutDate = dayjs(this.calc_estmatSoldoutDate)

      return round(
        add(
          divide(
            subtract(submitQty, advQtyAfterRepPerDay),
            divide(add(advQtyBeforeRepPerDay, soldQtyAfterRepPerDay), 2)
          ),
          subtract(90, estmatSoldoutDate.diff(today) / (1000 * 60 * 60 * 24))
        ),
        2
      )
    },
  },
  watch: {
    calc_estmatDaysOfSupply: {
      handler(e) {
        this.changeObj('estmatDaysOfSupply', e)
      },
      immediate: true,
      deep: true,
    },
    calc_estmatSoldoutDate: {
      handler(e) {
        this.changeObj('estmatSoldoutDate', e)
      },
      immediate: true,
      deep: true,
    },
    calc_suggestedSubmitQty: {
      handler(e) {
        this.changeObj('suggestedSubmitQty', e)
      },
      immediate: true,
      deep: true,
    },
    calc_suggestedReplenishmentDate: {
      handler(e) {
        this.changeObj('suggestedReplenishmentDate', e)
      },
      immediate: true,
      deep: true,
    },
    calc_etaInvDays: {
      handler(e) {
        this.changeObj('etaInvDays', e)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * 修改源对象
     * @param {*} key
     * @param {*} val
     * @returns
     */
    changeObj(key, val) {
      this.formData[key] = val
    },
  },
}
